import { API_ROUTE } from "#api";

export function get_image_url_for_user(userId) {
  return `${API_ROUTE}/file/userImage/${userId}`;
}
